<template>
  <v-row  v-on:click="toggleCard()">

    <transition name="flip">
      <v-col v-bind:key="data.flipped">
        <section v-if="!data.flipped" class="card card-front">

          <section 
            class="section-image" :style="sectionStyle">
            <v-img
              :src="require('@/assets/img/user.png')"
              class="img-photo"
              fixed
            >
            </v-img>
          </section>
          
          <section class="section-title pl-2 pr-2">
            <h3>{{ data.name +' '+ data.lastname }}</h3>
          </section>

          <section class="section-flag">
            <v-img
              v-if="url_flag"
              v-bind:src="url_flag"
              class="img-flag"
              fixed
            >
            </v-img>
          </section>

          <section class="section-povincia pl-2 pr-2">
            <h5 
              style="font-weight: 400;" 
              class="text--secondary"
              v-if="data.country!=null">
              {{ (data.country.name.toLowerCase()=='argentina')?data.provincia.name:data.other_country }}
            </h5>
          </section>

          <section class="section-social">

            <div @click="handleIconClick(data.user_id)">
              <v-icon>
                mdi-message-outline
              </v-icon>
            </div>

            <a v-if="data.web" :href="data.web" target="_blank">
              <v-icon>
                mdi-web
              </v-icon>
            </a>

            <a v-if="data.linkedin" :href="data.linkedin" target="_blank">
              <v-icon>
                mdi-linkedin
              </v-icon>
            </a>

            <a v-if="data.facebook" :href="data.facebook" target="_blank">
              <v-icon>
                mdi-facebook
              </v-icon>
            </a>

            <a v-if="data.instagram" :href="data.instagram" target="_blank">
              <v-icon>
                mdi-instagram
              </v-icon>
            </a>

            <a v-if="data.twitter" :href="data.twitter" target="_blank">
              <v-icon>
                mdi-twitter
              </v-icon>
            </a>

            <a v-if="data.youtube" :href="data.youtube" target="_blank">
              <v-icon>
                mdi-youtube
              </v-icon>
            </a>

            <a v-if="data.whatsapp" :href="data.whatsapp" target="_blank">
              <v-icon>
                mdi-whatsapp
              </v-icon>
            </a>

            <a v-if="data.telegram" :href="data.telegram" target="_blank">
              <v-icon>
                mdi-send
              </v-icon>
            </a>

            <a v-if="data.discord" :href="data.discord" target="_blank">
              <v-icon>
                mdi-discord
              </v-icon>
            </a>

            <a v-if="data.twitch" :href="data.twitch" target="_blank">
              <v-icon>
                mdi-twitch
              </v-icon>
            </a>

            <a v-if="data.tiktok" :href="data.tiktok" target="_blank">
              <v-img  
                contain
                height="20px" 
                width="20px"
                position="center" 
                :src="require('@/assets/icons/tiktok.png')">
              </v-img>
            </a>

            <a v-if="data.snapchat" :href="data.snapchat" target="_blank">
              <v-icon>
                mdi-snapchat
              </v-icon>
            </a>

            <a v-if="data.email" :href="'mailto:'+data.email" target="_blank">
              <v-icon>
                mdi-email
              </v-icon>
            </a>
          </section>
          
        </section>

        <section v-if="data.flipped" class="card card-back">

          <section class="section-category">
            <p>
              <small class="section-category-small">CATEGORÍA</small>
              <br>
              {{ data.type_postulation.name }}
            </p>
          </section>
          
          <section class="section-project">
            <p>{{ data.entrepreneurship_window.title }}</p>
          </section>

          <section class="section-btn">
            <v-btn
              v-if="data.entrepreneurship_window.slug"
              small
              color="primary"
              outlined
              :to="{ name: 'showProject', params: { slug: data.entrepreneurship_window.slug } }">
              Ver Stand
            </v-btn>
          </section>

          <section class="section-btn-me">
            <v-btn
              v-if="data.about_me"
              small
              text
              color="primary"
              @click.stop="showAboutMe(data.name, data.about_me)">
              Acerca de mí 
            </v-btn>
          </section>
          
        </section>  
      </v-col>

    </transition>

    <v-dialog
      v-model="dialog_message"
      persistent
      max-width="380"
    >
      <v-card>
        <v-card-title class="text-h5">
          Mensaje privado
        </v-card-title>
        <v-card-text>
          {{ data.name+ ' ' + data.lastname }}
          
            <v-textarea
              outlined
              class="pt-4"
              name="input-7-4"
              label="Mensaje"
              v-model="message"
            ></v-textarea>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="dialog_message = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!message"
            color="primary"
            text
            @click="sendMessage()"
            :loading="loading_send"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_about_me"
      max-width="460">
      <v-card>
        <v-card-title>
          Acerca de {{ entrepreneur_name }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-caption mt-4 text">
              {{ about_me }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_about_me = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardParticipant',
    props:['data', 'backgroundCardParticipant'],

    data: () => ({
      show_card:false,
      loading:false,
      loading_send:false,
      dialog_message:false,
      dialog_about_me:false,
      entrepreneur_name: '',
      about_me:'',
      message:'',
      receiver_id: null,
      flipped: false,
      newFront: '',
      newBack: '',
      error: false,

      url_photo:null,
      base_url: null,
      url_flag: null
    }),
    computed: {
      sectionStyle() {
        return {
          backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9)), url(${this.backgroundCardParticipant})`
        }
      }
    },
    methods:{    
      createURL(){
        this.url_photo = this.base_url + this.data.photo
        if(this.data.country!=null){
          this.url_flag = this.base_url + this.data.country.flag
        }
        this.show_card = true
      },

      toggleCard: function() {
        this.data.flipped = !this.data.flipped;
      },

      handleIconClick(id){
        this.receiver_id = id
        this.message = ''
        this.dialog_message = true
      },

      showAboutMe(name, about_me){
        this.entrepreneur_name = name
        this.about_me = about_me
        this.dialog_about_me= true
      },  

      async sendMessage()
      {
        try {
          this.loading_send = true
          await axios.post('messages',{
            message: this.message, 
            receiver_id: this.receiver_id, 
            }).then(response =>{
              this.message = ''
              this.dialog_message = false
              this.loading_send = false
              console.log(response)
            })
          } catch (error) {
              this.message = ''
              this.dialog_message = false
              this.loading_send = false
              console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
ul {
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}

li {
  list-style-type: none;
  padding: 10px 10px;
  transition: all 0.3s ease;
}

.container {
  max-width: 100%;
  padding: 2em;
}
.card {
  outline: 1px solid #E0E0E0;
  height: 350px;
  width: 240px!important;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 8px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.card-back {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.img-photo {
  max-height: 116px;
  max-width: 116px;
  min-height: 116px;
  min-width: 116px;
  border-radius: 50%; 
}
.img-flag{
  height: auto;
  max-width: 32px;
}
.section-image {
  display: flex;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  justify-content: center;
  align-items: center;
  height: 140px;
  background-size: contain;
  background-repeat: repeat;
  background-position: center;
}
.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
}
.section-title h3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;   /* máximo 3 líneas */
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 300;
  text-transform: uppercase;
}
.section-flag {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}
.section-povincia {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}
.section-social {
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: center;
  align-items: center;
  height: 52px;
  flex-wrap: wrap;
}

.section-social::-webkit-scrollbar {
  display: none;
}

.section-category {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  padding-left: 24px;
  padding-right: 24px;
}
.section-category-small{
  font-size: 11px;
  font-weight: 700;
}
.section-project {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
  height: 187px;
}
.section-project p {
  display: -webkit-box;
  -webkit-line-clamp: 7;   /* máximo 7 líneas */
  line-clamp: 7; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 24px;
  font-weight: 500;
}

.section-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight:500;
  padding-left: 24px;
  padding-right: 24px;
  height: 38px;
}

.section-btn-me{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight:500;
  padding-left: 24px;
  padding-right: 24px;
  height: 38px;
}

li:hover{
  transform: scale(1.02);
}

.flip-enter-active {
  transition: all .9s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter, .flip-leave {
  transform: rotateY(180deg);
  opacity: 0;

}

/* Form */
.flashcard-form{
  position: relative;
}


</style>